// extracted by mini-css-extract-plugin
export default {"filter__button":"OpportunityFilter_filter__button__VvupI","labelActive":"OpportunityFilter_labelActive__2qBAF"};